import classNames from 'classnames'
import { Button } from '@winnin/winnin_ui.components.button'
import type { TProviders } from '@winnin/winnin_ui.components.provider-icon'
import { ProviderIcon } from '@winnin/winnin_ui.components.provider-icon'

import { Refresh } from 'assets/icons'
import CreatorCardOnHover from 'components/CreatorCardOnHover'
import LiveStateTime from 'components/VideoContent/components/LiveStateTime'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'
import formatDate from 'utils/formatDate'

import { VideoStatusDescription } from '../video-status-description'
import { translations } from './video-info.i18n'
import type { IVideoInfoReturnProps } from './video-info.types'
import './video-info.styles.scss'

const noop = () => {}

export const VideoInfoView = ({
  providerName,
  creator,
  title,
  creatorId,
  provider,
  publishedAt,
  live,
  minimalVersion,
  isUpdatingPost,
  verifyUpdatePost,
  handleUpdatePost,
  statusPost,
  statusPostResponse,
  hasQueryError,
  postUrl,
}: IVideoInfoReturnProps) => {
  const t = useTranslate()

  return (
    <div className="video-info-top">
      <div className="video-creator">
        <div className="provider">
          {providerName && (
            <ProviderIcon
              icon={provider as TProviders}
              height={provider === 'yt' ? 20 : 26}
              width={provider === 'yt' ? 29 : 26}
              aria-label={providerName}
            />
          )}
        </div>
        <span className="video-creator-label">{t(translations.labelBy)} </span>
        <div className="video-creator-link">
          {creator && (
            <CreatorCardOnHover
              videoTitle={title}
              type={creator?.__typename ?? ''}
              noHover={minimalVersion}
              noLink={minimalVersion}
              title={creator?.title ?? ''}
              id={creatorId}
              provider={provider}
              groupId={creator?.groupId ?? ''}
              onCreatorClickCallback={noop}
            />
          )}
        </div>
      </div>

      <div className="video-published-at">
        {publishedAt && (
          <div className="published-at">
            {live ? <LiveStateTime live={live} /> : t(translations.labelPublished({ date: formatDate(publishedAt) }))}
          </div>
        )}
        {statusPostResponse && (
          <VideoStatusDescription
            statusPost={statusPost}
            statusPostResponse={statusPostResponse}
            publishedAt={publishedAt}
            postUrl={postUrl}
          />
        )}
        {hasQueryError && <span className="error-message">{t(translations.errorLoadingStatus)}</span>}
        {verifyUpdatePost && statusPostResponse?.canUpdate && (
          <Button
            onClick={handleUpdatePost}
            type="button"
            appearance="outline"
            className="update-post-button"
            disabled={isUpdatingPost}
            aria-busy={isUpdatingPost}
            aria-label={isUpdatingPost ? t(translations.ariaUpdating) : t(translations.ariaUpdate)}
          >
            <Refresh
              aria-hidden="true"
              className={classNames({ 'update-post-button__icon--spinning': isUpdatingPost })}
            />
            <p>{t(TOLGEE_GLOBALS.update)}</p>
          </Button>
        )}
      </div>
    </div>
  )
}
